import { Maybe } from '../../../__generated__/globalTypes'

import qualificationFragmentRawString from '../QualificationFragment.graphql'

export const qualificationFragmentString = qualificationFragmentRawString

export type QualificationFragment = {
  id: string
  title: string
  description: string
  graphic: string
  threshold: number
  progress: number
  link: Maybe<{
    title: string
    url: string
  }>
}

export const isQualificationFragment = (
  fragment: any,
): fragment is QualificationFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  typeof fragment.description === 'string' &&
  typeof fragment.graphic === 'string' &&
  typeof fragment.threshold === 'number' &&
  typeof fragment.progress === 'number' &&
  (fragment.link === null ||
    (fragment.link &&
      typeof fragment.link.title === 'string' &&
      typeof fragment.link.url === 'string'))
